import { questionTypeToLabel } from '@/features/test-paper/utils'
import React from 'react'
import styled from 'styled-components'
import { ScoreInputNumber } from './ScoreInputNumber'
import { ScoreSettingProps } from '../types'

/**
 * 通用分数设置组件 - 单选|多选|简答
 * @param param - 参数
 * @param param.block - 题目对应的block
 * @param param.question - 当前题目
 * @param param.serialNumber - 序号
 * @param param.onUpdateScore - 更新分数
 * @returns React.ReactNode
 */
export const CommonScoreSetting: React.FC<ScoreSettingProps> = (props) => {
  const { question, serialNumber } = props
  return (
    <Wrapper>
      <div>
        {serialNumber}
        {questionTypeToLabel.get(question.type)}
      </div>
      <ScoreInputNumber {...props} />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div {
    font-size: 14px;
    color: ${(props) => props.theme.text._1};
  }
`
